export default __webpack_public_path__ + "media/landscape/logo_vimeo-9d2e4053.svg";